module.exports = __webpack_public_path__ + "img/logo_small.64d5d862.png";